module.exports = __webpack_public_path__ + "static/img/ddemr.dfb0c26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ddemr.png
// module id = eOGK
// module chunks = 0